import routes from 'routes'
import useBalanceTotal from 'hooks/helpers/useBalanceTotal'
import {useProfile} from 'hooks'
import {translatedUrl} from 'i18n/utils'

import {Container, InfoCol, Balance, Name, ProfileAvatar} from './ProfileNavItem.styles'

const ProfileNavItem = ({...rest}) => {
  const {profile} = useProfile()
  const {data} = useBalanceTotal()

  if (!profile) return null
  return (
    <Container to={translatedUrl(routes.profile.path)} {...rest}>
      <ProfileAvatar />
      <InfoCol>
        <Name>
          {profile.first_name} {profile.last_name}
        </Name>
        <Balance>{data == null ? '-' : data}</Balance>
      </InfoCol>
    </Container>
  )
}

export default ProfileNavItem
